//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import { mdiFilterVariant } from '@mdi/js'

export default {
  setup() {
    const chips = ref(['Programming', 'Playing video games', 'Sleeping'])
    const items = ref(['Streaming', 'Eating'])

    const remove = item => {
      chips.value.splice(chips.value.indexOf(item), 1)
      chips.value = [...chips.value]
    }

    return {
      chips,
      items,
      remove,
      icons: {
        mdiFilterVariant,
      },
    }
  },
}
